import {useSelectedDocContext} from '../../../../search-hooks';
import React from 'react';
import {AttributesList} from './attributes-list/attributesList';
import classNames from 'clsx';

export const BaseDataRow = (): JSX.Element | null => {
    const doc = useSelectedDocContext();
    if (!doc) {
        return null;
    }

    return (
        <div className={classNames('document-infos', 'details-body-base-data')}>
            <AttributesList attributes={['id', 'language', 'contentSource']}/>
        </div>
    );
};
